const About = () => {
  return (
    <div name="about" className="font-montserrat bg-white px-5 lg:px-0 py-6 lg:py-12 flex justify-center">
      <div className="lg:w-8/12 ">
     <h1 className="text-primary font-semibold text-2xl lg:text-3xl text-center mb-2 lg:mb-4">About Macro Pathways</h1>
      <p className="font-medium text-dark-gray text-sm lg:text-lg mb-2">Macro Pathways is a project dedicated to addressing the Micro Pipeline in Social Work (MPISW),
         a systemic pattern that channels social workers into clinical and direct care practice roles while leaving macro practice pathways underdeveloped and underrepresented. Our mission is to bridge that gap by creating visibility, access, and legitimacy for macro-level roles in social work.
         </p>
         <p className="font-medium text-dark-gray text-sm lg:text-lg mb-2">
               We believe social work is not only about responding to individual needs but also about transforming the systems that shape those needs. Through curated macro-focused job updates, workshops, and future initiatives, Macro Pathways helps social workers expand their impact beyond traditional practice settings and step into positions where they can influence policy, systems, and communities.
          </p>
         <p className="font-medium text-dark-gray text-sm lg:text-lg mb-2">
          This platform is designed to be both a resource and a movement. It challenges the profession to return to its roots in social change and equips social workers to lead at the systems level.
          </p>



      </div>
      </div>
  )
}

export default About
